import {
  Button,
  Chip,
  CircularProgress,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TimezoneSelect from "react-timezone-select";
import { validateEmail } from "../../Utils/validation";
import { CheckEmailExist, PublicUserInfo, SendEmailOTP } from "../Auth/Helper";
import { useCommonUserProvider } from "../../Providers/Common/User";
import Swal from "sweetalert2";
import { Modal } from "antd";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../Components/Table";
import moment from "moment/moment";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { userPermissions } from "../../Utils/constants";
import { useSelector } from "react-redux";

const Settings = (props) => {
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { changePassword, updateUser, getChildUsers, childUsers, userCount } =
    useCommonUserProvider();
  const permissions = useSelector((state) => state.user.permissions);
  const [emailUsed, setEmailUsed] = useState(false);
  const userId = localStorage.getItem("userId");
  const [user, setUser] = useState({
    timezone: "Etc/GMT",
  });
  const [open, setOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpToken, setOtpToken] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    PublicUserInfo({ userId: userId })
      .then((res) => {
        setValue("email", res.data.result.email);
        setUser({
          ...res.data.result,
          name: `${res.data.result?.firstName ?? ""} ${
            res.data.result?.lastName ?? ""
          }`.trim(),
        });
      })
      .catch((err) => {
        console.log(err);
      });
    getChildUsers(0, 5);
  }, []);

  useEffect(() => {}, [childUsers]);
  const checkEmailUsed = (email) => {
    if (process.env.REACT_APP_BASE_URL === "https://dev.api.prolegion.com") {
      if (
        email.split("@")[1] === "yopmail.com" ||
        email.split("@")[1] === "test.com"
      ) {
        Swal.fire("Invalid Email!", "Please enter a correct email...", "error");
      }
    }

    CheckEmailExist({ email: email }).then((res) => {
      if (user?.email === email) {
        setEmailUsed(false);
      } else {
        setEmailUsed(res?.data?.status);
      }
    });
  };

  const sendUpdatePasswordEmail = () => {
    changePassword()
      .then((res) => {
        if (res) {
          Swal.fire("", "Email send successfully", "success");
        } else {
          Swal.fire("", "Something went wrong", "info");
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire("Oops", "Something went wrong", "error");
      });
  };

  const showModal = (formData) => {
    if (!emailUsed) {
      SendEmailOTP({ email: formData.email })
        .then((res) => {
          console.log(res);
          setOtpToken(res.data.token);
          if (res?.data.token) {
            setOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const resendOTP = () => {
    if (otpToken === "") {
      SendEmailOTP({ email: user.email })
        .then((res) => {
          console.log(res);
          setOtpToken(res.data.token);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      SendEmailOTP({ email: user.email, OTPToken: otpToken })
        .then((res) => {
          console.log(res);
          setOtpToken(res.data.token);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleOk = () => {
    // setOpen(false);
    updateUser({
      OTP: otp,
      OTPToken: otpToken,
      email: user.email,
      timezone: user.timezone,
    })
      .then((data) => {
        if (!data?.data?.success) {
          Swal.fire("Oops!", "Invalid OTP or OTP is expired", "info");
        } else if (data?.data?.success) {
          Swal.fire("", "Profile updated successfully", "success");
          setOpen(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleChangePage = (newPage, rowsPerPage) => {
    getChildUsers(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (limit) => {
    getChildUsers(0, limit);
  };

  const onSubmit = (formData) => {
    setUser({
      ...user,
      email: formData?.email,
    });
    if (formData.email !== user?.email) {
      showModal(formData);
    } else {
      updateUser({ email: formData.email, timezone: user.timezone })
        .then((res) => {
          Swal.fire("", "Timezone successfully", "success");
        })
        .catch((err) => {
          console.log(err);
          Swal.fire("Oops", "Something went wrong", "error");
        });
    }
  };
  return (
    <div>
      {permissions?.includes(`admin-client`) ||
      permissions?.includes(`admin-vendor`) || permissions?.includes(`admin-consultant`)? (
        <div className="py-4 px-8 font-[Roboto] bg-white rounded-lg shadow-md shadow-gray-400">
          <h1
            className="text-2xl font-semibold pt-2"
            style={{ color: "#2EBAA3" }}
          >
            Settings
          </h1>
          <br />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <h1 className="text-base pb-3">Update Email</h1>
              <div className="pb-5">
                <TextField
                  className="pt-2"
                  id="outlined-basic"
                  {...register("email", { validate: validateEmail })}
                  label="Email ID"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors?.email ? true : false}
                  helperText={errors?.email?.message}
                  onBlur={(e) => {
                    checkEmailUsed(e.target.value);
                  }}
                  variant="outlined"
                  fullWidth
                />
                {emailUsed ? (
                  <h4 className="text-red-600 text-xs pt-2 pb-4">
                    Email is already used
                  </h4>
                ) : (
                  " "
                )}
              </div>
              <h1 className="text-base pb-3">Change Password</h1>
              <div className="w-50">
                <Button
                  variant="contained"
                  style={{ color: "#FFFFFF" }}
                  onClick={(e) => sendUpdatePasswordEmail()}
                >
                  Get link by email
                </Button>
              </div>
              <br />
              <h1 className="text-base pb-3">Timezone</h1>
              <div className="select-wrapper">
                <TimezoneSelect
                  //defaultInputValue="user?.timezone"
                  value={{ value: user.timezone }}
                  onChange={(e) => {
                    setUser({ ...user, timezone: e.value });
                  }}
                  labelStyle="abbrev"
                  theme={{
                    colors: {
                      primary: "#2EBAA3",
                      primary25: "rgba(46, 186, 163, 0.3)",
                      primary50: "rgba(46, 186, 163, 0.3)",
                      primary75: "rgba(46, 186, 163, 0.3)",
                      neutral0: "#ffffff",
                    },
                  }}
                />
              </div>
              <div className="text-right pt-7">
                <Button
                  variant="contained"
                  type="submit"
                  style={{ color: "#FFFFFF" }}
                >
                  Update Details
                </Button>
              </div>
            </div>
          </form>
          <Modal
            title={
              <span className="font-medium text-[24px] leading-[36px]">
                Verify Email
              </span>
            }
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            okButtonProps={{
              className: "font-medium h-auto py-1 text-[17px] px-6 mt-6",
              style: { backgroundColor: "#139588" },
            }}
            okText="Verify"
            cancelButtonProps={{ hidden: true }}
          >
            <h4 className="text-center text-[16px] leading-[24px] mt-7 mb-1.5">
              Enter OTP received on your email
            </h4>
            <OTPInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              inputStyle={{
                width: "60px",
                height: "54px",
                borderWidth: 1,
                borderColor: "#139588",
                outline: "none",
                borderRadius: 5,
              }}
              containerStyle={{
                flex: 1,
                justifyContent: "center",
                marginBottom: 8,
              }}
              renderSeparator={<span className="w-1.5" />}
              renderInput={(props) => <input {...props} />}
            />
            <span
              className="text-[#2196F3] text-[16px] leading-[24px] cursor-pointer ml-10"
              onClick={resendOTP}
            >
              Resend OTP
            </span>
          </Modal>
        </div>
      ) : null}

      <br />
      {permissions?.includes(`admin-client`) ||
      permissions?.includes(`admin-vendor`) ||
      permissions?.includes(userPermissions.settings.edit) ? (
        <div className="py-4 px-8 font-[Roboto] bg-white rounded-lg shadow-md shadow-gray-400">
          <div class="flex w-full justify-between pt-2">
            <div class="flex-none">
              <h3
                className="text-2xl font-semibold  col-span-5 inline"
                style={{ color: "#2EBAA3" }}
              >
                Users
              </h3>
            </div>
            <div className="flex flex-row-reverse">
              <Button
                type="submit"
                variant="contained"
                style={{ color: "white" }}
                onClick={() => {
                  navigate("/dashboard/user/adduser");
                }}
              >
                Add User
              </Button>
            </div>
          </div>
          <br />
          <CustomTable
            title=""
            headCells={[
              "Name",
              "Email",
              "Invited On",
              "Joined on",
              "Status",
              "Action",
            ].map((label) => ({ label }))}
            rows={childUsers}
            CustomRow={CustomRow}
            showHeaderOnEmpty={true}
            showDensePadding={false}
            count={userCount}
            defaultRowsPerPage={5}
            customHandleChangePage={handleChangePage}
            customHandleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Settings;

const CustomRow = ({ row, page, rowsPerPage, reloadTable }) => {
  const navigate = useNavigate();
  const { enableDisableUser, loading } = useCommonUserProvider();
  const [id, setId] = useState();
  const userAction = (id) => {
    setId(id);
    enableDisableUser(id, page, rowsPerPage);
  };
  return (
    <TableRow hover tabIndex={-1} key={row?.user?.id}>
      <TableCell>
        {row?.user?.firstName} {row?.user?.lastName}
      </TableCell>
      <TableCell>{row?.user?.email}</TableCell>
      <TableCell>{moment.utc(row?.createdAt).format("DD/MM/YYYY")}</TableCell>
      <TableCell>
        {moment.utc(row?.user?.createdAt).format("DD/MM/YYYY")}
      </TableCell>
      <TableCell component="th">
        {row?.user?.isBlocked ? (
          <Chip label={"Blocked"} color="error" variant="outlined" />
        ) : (
          <Chip label={"Active"} color="primary" variant="outlined" />
        )}
      </TableCell>
      {
        loading && row?.user?.id===id ? 
        <TableCell align="center">
          <CircularProgress size={30} />
        </TableCell>
        :
        <TableCell align="center">
          <div class="flex space-x-4">
            <Tooltip title="Edit User">
              <IconButton
                onClick={() => {
                  navigate(`edituser/${row?.user?.id}`);
                  window.location.reload();
                }}
              >
                <ManageAccountsIcon color="primary" />
              </IconButton>
            </Tooltip>
            <Tooltip title={row?.user?.isBlocked ? "Enable" : "Disable"}>
              <IconButton
                onClick={(e) => {
                  userAction(row?.user?.id);
                }}
              >
                {row?.user?.isBlocked ? (
                  <NoAccountsIcon className="cursor-pointer" color="primary" />
                ) : (
                  <NoAccountsIcon className="cursor-pointer" color="error" />
                )}
              </IconButton>
            </Tooltip>
          </div>
        </TableCell>
      }
    </TableRow>
  );
};